import PropTypes from 'prop-types';
import { BILLING_PERIODS } from '../../utils/constants';

export default function PeriodToggle({ period, disabled, onToggle }) {
    return (
        <div className="checkout-summary-switch">
            <button
                className={period === BILLING_PERIODS.MONTH ? 'active' : null}
                onClick={() => onToggle(BILLING_PERIODS.MONTH)}
                disabled={disabled}
            >
                Monthly
            </button>
            <button
                className={period === BILLING_PERIODS.YEAR ? 'active' : null}
                onClick={() => onToggle(BILLING_PERIODS.YEAR)}
                disabled={disabled}
            >
                Yearly
            </button>
        </div>
    );
}

PeriodToggle.propTypes = {
    period: PropTypes.string,
    disabled: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
};
